export default "__VITE_ASSET__DyqtKEOM__"